/** 
 * @type {ProjectValuationsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    project_ids: null,
    years: null,
}
/** 
* @returns {ProjectValuationsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ProjectValuationsFilter.js